import { Rarity, Sport } from '#src/__generated__/globalTypes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

import { useSeriesNav } from '../commonGame/useSeriesNav';

const AUTHORIZED_RARITIES = [
  Rarity.common,
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

export const useAvailableRarities = (): Rarity[] => {
  const { sport } = useSportContext();
  const isSimplifiedNav = useSeriesNav();
  if (sport === Sport.BASEBALL) {
    return AUTHORIZED_RARITIES.filter(r => r !== Rarity.common);
  }
  if (isSimplifiedNav) {
    return [Rarity.common];
  }
  return AUTHORIZED_RARITIES.filter(r => r !== Rarity.common);
};
